import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import TextField from "@mui/material/TextField";
import { Preloader } from "../common/index.js";
import ReactInputMask from "../../ReactInputMask/index.js";
import MultipleSuggestedInput_styles from "./MultipleSuggestedInput.styles.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function TextFieldMasked_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else TextFieldMasked_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
function _object_without_properties(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys, key, i;
    if ("u" > typeof Reflect && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (!(excluded.indexOf(key) >= 0)) {
            if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
        }
    }
    return target;
}
const TextFieldMasked = (t0)=>{
    var _rest_inputProps, _rest_inputProps1, _rest_inputProps2, _rest_inputProps3, _rest_inputProps4;
    const $ = c(34);
    let error;
    let helperText;
    let id;
    let loading;
    let mask;
    let name;
    let onChange;
    let rest;
    if ($[0] !== t0) {
        ({ id, mask, name, error, helperText, loading, onChange } = t0), rest = _object_without_properties(t0, [
            "id",
            "mask",
            "name",
            "error",
            "helperText",
            "loading",
            "onChange"
        ]);
        $[0] = t0;
        $[1] = error;
        $[2] = helperText;
        $[3] = id;
        $[4] = loading;
        $[5] = mask;
        $[6] = name;
        $[7] = onChange;
        $[8] = rest;
    } else {
        error = $[1];
        helperText = $[2];
        id = $[3];
        loading = $[4];
        mask = $[5];
        name = $[6];
        onChange = $[7];
        rest = $[8];
    }
    const { classes } = MultipleSuggestedInput_styles();
    let t1;
    if ($[9] !== onChange) {
        t1 = (e)=>{
            onChange(e, e.target.value);
        };
        $[9] = onChange;
        $[10] = t1;
    } else t1 = $[10];
    const handleChange = t1;
    const t2 = null == (_rest_inputProps = rest.inputProps) ? void 0 : _rest_inputProps.value;
    const t3 = null == (_rest_inputProps1 = rest.inputProps) ? void 0 : _rest_inputProps1.onFocus;
    const t4 = null == (_rest_inputProps2 = rest.inputProps) ? void 0 : _rest_inputProps2.onBlur;
    const t5 = null == (_rest_inputProps3 = rest.inputProps) ? void 0 : _rest_inputProps3.onKeyDown;
    const t6 = null == rest ? void 0 : null == (_rest_inputProps4 = rest.inputProps) ? void 0 : _rest_inputProps4.ref;
    let t7;
    if ($[11] !== classes.inputRoot) {
        t7 = {
            root: classes.inputRoot
        };
        $[11] = classes.inputRoot;
        $[12] = t7;
    } else t7 = $[12];
    let t8;
    if ($[13] !== loading) {
        t8 = loading ? {
            slotProps: {
                input: {
                    endAdornment: /*#__PURE__*/ jsx(Preloader, {})
                }
            }
        } : {};
        $[13] = loading;
        $[14] = t8;
    } else t8 = $[14];
    let t9;
    if ($[15] !== error || $[16] !== helperText || $[17] !== id || $[18] !== name || $[19] !== rest || $[20] !== t6 || $[21] !== t7 || $[22] !== t8) {
        t9 = /*#__PURE__*/ jsx(TextField, _object_spread(_object_spread_props(_object_spread({}, rest), {
            id: id,
            inputRef: t6,
            name: name,
            classes: t7,
            autoComplete: "off",
            variant: "outlined",
            fullWidth: true,
            error: error,
            helperText: helperText,
            placeholder: rest.placeholder
        }), t8));
        $[15] = error;
        $[16] = helperText;
        $[17] = id;
        $[18] = name;
        $[19] = rest;
        $[20] = t6;
        $[21] = t7;
        $[22] = t8;
        $[23] = t9;
    } else t9 = $[23];
    let t10;
    if ($[24] !== handleChange || $[25] !== mask || $[26] !== name || $[27] !== rest.disabled || $[28] !== t2 || $[29] !== t3 || $[30] !== t4 || $[31] !== t5 || $[32] !== t9) {
        t10 = /*#__PURE__*/ jsx(ReactInputMask, {
            value: t2,
            onFocus: t3,
            onBlur: t4,
            onKeyDown: t5,
            mask: mask,
            name: name,
            onChange: handleChange,
            disabled: rest.disabled,
            children: t9
        });
        $[24] = handleChange;
        $[25] = mask;
        $[26] = name;
        $[27] = rest.disabled;
        $[28] = t2;
        $[29] = t3;
        $[30] = t4;
        $[31] = t5;
        $[32] = t9;
        $[33] = t10;
    } else t10 = $[33];
    return t10;
};
export { TextFieldMasked };
